import { Columns, Sorts } from '#types/grid';

import { sortOrderToNumber } from './sort-order-to-number';

export function getSorts(columns: Columns): Sorts {
  const sort: Sorts = {};

  // column sorts
  const sortedColumns: string[] = [];

  // first, add columns that have a sort order specified
  for (const column of columns) {
    if (column.sortable && column.sort && column.sortOrder) {
      sortedColumns.push(column.field);
      sort[column.field] = { order: sortOrderToNumber(column.sort) };
    }
  }

  // second, add any columns that do not have an order specified to the end
  for (const column of columns) {
    if (!sortedColumns.includes(column.field) && column.sortable && column.sort && column.sortOrder) {
      sortedColumns.push(column.field);
      sort[column.field] = { order: sortOrderToNumber(column.sort) };
    }
  }

  return sort;
}
